import React from 'react';

import { IRouter } from '@routers/interface';

export const routerAccessExpired: IRouter = {
  path: '/access-expired',
  masterLayout: false,
  loader: React.lazy(() => import('./index')),
};
